<template>
    <m-layout>
      <div fill-height class="fill-height" style="max-width:100%; position:relative">
        <v-card-title class="m-page__title">
          <span class="headline">M-code</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
        </v-card-title>
        <m-confirm ref="confirm"></m-confirm>
        <m-code-form :form="form" :mdata="selectedItem" :dialog="dialog" @save="onSave" @close="onClose"></m-code-form>
        <m-code-edit-form :form="form" :mdata="selectedItem" :dialog="dialog_edit" @update="onUpdate" @close="onClose"></m-code-edit-form>

        <v-card style="max-width:100%; position:relative">
          <v-card-title>
            <v-btn
              absolute
              dark
              fab
              top
              right
              color="primary"
              @click.native.stop="dialog = true">
              <v-icon>add</v-icon>
            </v-btn>

            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          <v-spacer></v-spacer>
          <m-csv-btn class="pt-3" :disabled="items.length === 0" :data="items" filename="mcode.csv"></m-csv-btn>
          </v-card-title>
          <v-data-table
              v-bind:headers="headers"
              v-bind:items="items"
              v-bind:search="search"
              :footer-props="{
                'items-per-page-options': [5, 10, 30, 40, {text:'All', value:-1}]
              }"
            >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
              <td >{{ item.id }}</td>
              <td >{{ item.mcode}}</td>
              <td >{{ item.name }}</td>
              <td >{{ item.price_other }}</td>
              <td >{{ item.price_dialyse }}</td>
              <td >{{ item.price_radio }}</td>
              <td >{{ item.price_chemo }}</td>
              <td>
                <div style="display: flex">
                <v-btn icon class="mx-0" @click="editItem(item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="deleteItem(item)">
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
                </div>
              </td>
            </tr>
            </tbody>
          </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </v-card>


      </div>
    </m-layout>
</template>

<script>
  import McodeMixin from '@/mixins/mcode'

  export default {
    mixins: [McodeMixin],
    data () {
      return {
      }
    }
  }
</script>

<style lang="scss">
.error {
  text-transform: none;
  color: grey;

  &-item {
    color:rgba(248, 1, 1, 1) !important;
  }
}
</style>









